import React, { useEffect, useState, useRef } from "react"
import { MDBDataTable } from "mdbreact"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Button,
    Modal,
    FormGroup,
    Form,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { Link } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb"
// Import images
import substrateImg from "../../assets/images/SubstrateImg.png"
import fruitingImg from "../../assets/images/fruiting1.png"

import "../Batch/datatables.scss"
import { useFormik } from "formik"
import * as Yup from "yup"
import axios from "axios"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatatableTables = props => {
    document.title = "Harvest Output | My Urban Farms"
    const adminKey = sessionStorage.getItem("pk_admin_key");

    const breadcrumbItems = [
        // { title: "Batch Details", link: "#" },
    ]

    const [output, setOutput] = useState([])
    const [farmList, setFarmList] = useState([])

    const [selectedFarmKey, setSelectedFarmKey] = useState("");
    const [isLoading, setIsLoading] = useState(false);




    useEffect(() => {
        props.setBreadcrumbItems("Output", breadcrumbItems)
        fetchReportsByBatch();
        fetchFarms();
    }, [])

    const fetchFarms = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/getAllFarms/farm/`
            );

            const resData = response.data;
            setIsLoading(false);

            if (resData.message?.success && Array.isArray(resData.message.data)) {
                setFarmList(resData.message.data);

                // Auto-select farm id=1 from list
                const defaultFarm = resData.message.data.find(f => f.pk_farm_id == 1);
                if (defaultFarm) {
                    setSelectedFarmKey(defaultFarm.pk_farm_key);
                }
            } else {
                console.warn("Unexpected data format", resData);
                setFarmList([]);
            }
        } catch (error) {
            console.error("Failed to fetch:", error);
            setIsLoading(false);
            setFarmList([]);
            toast.error("Failed to fetch!", { autoClose: 3000 });
        }
    };



    const fetchReportsByBatch = async (selectedFarmKey) => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/getAllOutput/harvest/`,
                { farmKey: selectedFarmKey }
            );

            const list = res.data.message?.data || [];

            const tableRows = list.map((item, index) => ({
                sno: index + 1,
                batch_num: item.batch_num,
                bag_num: item.bag_num,
                harvest_date: item.harvest_date,
                harvest_count: item.harvest_count,
            }));

            setOutput(tableRows);

        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch");
        }
    };

    useEffect(() => {
        if (selectedFarmKey) {
            fetchReportsByBatch
                (selectedFarmKey);
        }
    }, [selectedFarmKey]);


    const data = {
        columns: [
            { label: "S.No", field: "sno", sort: "asc", width: 50 },
            { label: "Batch Number", field: "batch_num", sort: "asc" },
            { label: "Bag Number", field: "bag_num", sort: "asc" },
            { label: "Harvest Date ", field: "harvest_date", sort: "asc" },
            { label: "Harvest Count (In grams)", field: "harvest_count", sort: "asc" },

        ],
        rows: []
    };

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb />

                <div className="mt-2 me-3" style={{ minWidth: "250px" }}>
                    <select
                        className="form-select"
                        value={selectedFarmKey}
                        onChange={(e) => setSelectedFarmKey(e.target.value)}
                    >
                        <option value="">-- Select Farm --</option>
                        {farmList.map((farm) => (
                            <option key={farm.pk_farm_key} value={farm.pk_farm_key}>
                                {farm.farm_name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <MDBDataTable
                                responsive
                                striped
                                bordered
                                data={{ ...data, rows: output }}
                                noBottomColumns
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>


        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(DatatableTables)
